<template>
  <v-app-bar
    density="compact"
    flat
    class="pa-0 ma-0 pl-6"
    scroll-behavior="hide"
    scroll-threshold="5"
  >
    <HeaderLogo />
    <v-spacer />

    <!-- Customer name -->
    <div
      v-if="$vuetify.display.smAndUp"
      class="text-accent text-caption"
    >
      {{ login.customer.customer_name }}
    </div>

    <!-- User profile Button -->
    <v-btn
      v-if="login.profile.email"
      color="accent"
      style="margin-right: -10px; text-transform: none;"
      size="large"
      @click.stop="ui.rightDrawer = !ui.rightDrawer"
    >
      <OpAvatar
        :profile="login.profile"
        :size="30"
        class="mr-2"
      />
      {{ login.profile.email }}
    </v-btn>
  </v-app-bar>
</template>

<script>
  import { mapGetters } from 'vuex'
  import HeaderLogo from '@/components/base/TheHeaderLogo'
  import OpAvatar from '@/components/parts/OpAvatar'

  export default {
    components: {
      OpAvatar,
      HeaderLogo
    },
    computed: {
      ...mapGetters([
        'login',
        'ui'
      ])
    }
  }
</script>

<style scoped>
</style>
